<template>
    <div>
        <v-tabs v-model="tab" grow class="mb-30px">
            <v-tab>Pagination</v-tab>
        </v-tabs>

        <v-window v-model="tab">
            <v-window-item><SwipersPagination /></v-window-item>
        </v-window>
    </div>
</template>

<script>
import GuideApp from "./guide-app.vue";

import SwipersPagination from "./swipers-pagination.vue";

export default {
    props: {},
    components: {
        GuideApp,

        SwipersPagination,
    },
    data() {
        return {
            tab: null,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
